module.exports = __webpack_public_path__ + "img/fist-zagreus.13ebaea1.jpg";